import { useSelector } from 'react-redux';
import { compareKeys } from 'helpers';
import { ApplicationState } from 'store/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useShallowSelector = <TSelected extends Record<string, any>>(
  selector: (state: ApplicationState) => TSelected,
  excludedKeys?: (keyof TSelected)[],
) =>
  useSelector(selector, (a, b) =>
    compareKeys(a, b, excludedKeys ? { excludeKeys: excludedKeys } : undefined),
  );

export default useShallowSelector;
